import styled from 'styled-components';

interface GridAreaProps {
    area: string;
}

const GridArea = styled.div<GridAreaProps>`
    grid-area: ${props => props.area};
`;

const ChecklistGuideContainer = styled.div`
    padding: 1.5rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    grid-column-gap: 1rem;
    grid-row-gap: 1rem;
    grid-template-areas: 'a1 a1 a2 a2 a3 a3';

    @media (max-width: ${props => props.theme.breakpoint.mobile}) {
        display: flex;
        flex-direction: column;
        row-gap: 1rem;
    }
`;

export { GridArea, ChecklistGuideContainer };
